import React, { useState } from 'react';
import PublisherTable from './table/js/publisherTable';
import PublisherCreate from './create/js/publisherCreate';

export default function PublisherManagement(){
  const [showCreate,setShowCreate]=useState(false);
  return (
    <div className="eduss-publisher-management">
      <div className="eduss-page-header"><h2>Publisher Management</h2><p>View and manage publisher records</p></div>
      <PublisherTable onCreatePublisher={()=>setShowCreate(true)} />

      {showCreate && (
        <div className="eduss-global-modal-overlay" onClick={()=>setShowCreate(false)}>
          <div className="eduss-global-modal eduss-admin-form-modal" onClick={e=>e.stopPropagation()}>
            <div className="eduss-global-modal-header"><h3>Create New Publisher</h3><button onClick={()=>setShowCreate(false)}>&times;</button></div>
            <div className="eduss-global-modal-content"><PublisherCreate onClose={()=>setShowCreate(false)} /></div>
          </div>
        </div>)}
    </div>
  );
}
